import { defineMessages } from 'react-intl';

export default defineMessages({
  ctaJoinHeading: {
    id: 'accountSignin.accountCreateCta.heading',
    description: 'Heading for account-create CTA section of signin',
    defaultMessage: 'Join { starbucksRewardsTrademark }',
  },
  ctaJoinShortMessage: {
    id: 'accountSignin.accountCreateCta.message',
    description: 'message to create an account',
    defaultMessage: 'Create an account and bring on the Rewards!',
  },
  ctaJoinFullMessage: {
    id: 'accountSignin.accountCreateCta.joinMessage',
    description: 'message discussing the benefits of Starbucks Rewards',
    defaultMessage:
      "As a member, start earning free food and drinks, unlock our best offers and celebrate your birthday with a treat from us. Best of all, it's free to join.",
  },
});
